function initBlogCarousels(){
  document.querySelectorAll('.js-home-blog-carousel').forEach(function (carousel) {
    const getNum = (name, fb = 0) => {
      const v = parseInt(carousel.getAttribute(name), 10);
      return isNaN(v) ? fb : v;
    };

    const perLg   = getNum('data-large-desktop-articles-per-row', 1);
    const perD    = getNum('data-desktop-articles-per-row', perLg);
    const perLap  = getNum('data-laptop-articles-per-row', perD);
    const perTab  = getNum('data-tablet-articles-per-row', perLap);
    const perMob  = getNum('data-mobile-articles-per-row', perTab);

    const gapLg   = getNum('data-large-desktop-articles-gap', 0);
    const gapD    = getNum('data-desktop-articles-gap', gapLg);
    const gapLap  = getNum('data-laptop-articles-gap', gapD);
    const gapTab  = getNum('data-tablet-articles-gap', gapLap);
    const gapMob  = getNum('data-mobile-articles-gap', gapTab);

    if (carousel.splideInstance) {
      carousel.splideInstance.destroy();
      carousel.classList.remove('is-splide-initialized');
    }

    var splide = new Splide(carousel, {
      type     : 'slide',
      perPage  : perLg,
      perMove  : 1,
      pagination: true,
      arrows   : true,
      rewind   : false,
      gap      : `${gapLg}px`,
      breakpoints: {
        1798: { perPage: perD,   gap: `${gapD}px`   },
        1499: { perPage: perLap, gap: `${gapLap}px` },
        991 : { perPage: perTab, gap: `${gapTab}px` },
        767 : { perPage: perMob, gap: `${gapMob}px` }
      }
    });

    splide.on('mounted', function () {
      if (splide.Components.Controller.getEnd() === 0) {
        var pagination = carousel.querySelector('.splide__pagination');
        if (pagination) pagination.style.display = 'none';
      }
    });

    splide.mount();

    carousel.classList.add('is-splide-initialized');
    carousel.splideInstance = splide;
  });
}

document.addEventListener('DOMContentLoaded', initBlogCarousels);

if (window.Shopify && Shopify.designMode) {
  const events = [
    'shopify:section:load',
    'shopify:section:select',
    'shopify:block:select',
    'shopify:block:deselect'
  ];
  events.forEach(eventName => {
    document.addEventListener(eventName, () => {
      setTimeout(initBlogCarousels, 50);
    });
  });
}